var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 201,
    viewBox: "0 0 161 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1914)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650513,
    width: 160,
    height: 200,
    rx: 8,
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.028 179.651V168.931H17.3V179.651H19.028ZM22.3561 179.651V175.715C22.3561 173.987 23.1401 173.091 24.8841 173.091C26.5321 173.091 27.2041 173.843 27.2041 175.331V179.651H28.9321V174.867C28.9321 173.027 27.8441 171.539 25.6361 171.539C23.6201 171.539 22.5641 172.819 22.3241 174.163H22.2121V171.699H20.6281V179.651H22.3561ZM34.2319 179.811C36.4719 179.811 37.9439 178.931 37.9439 177.443C37.9439 176.131 37.0799 175.491 35.1919 175.251L33.3519 174.995C32.1519 174.835 31.8319 174.611 31.8319 173.987C31.8319 173.235 32.3439 172.915 33.7999 172.915C35.5599 172.915 36.0399 173.411 36.0399 174.355V174.451H37.7519V174.403C37.7519 172.515 36.2799 171.539 33.8479 171.539C31.3999 171.539 30.1359 172.531 30.1359 173.923C30.1359 175.251 31.0479 175.891 32.5519 176.083L34.7279 176.371C35.8639 176.531 36.2479 176.739 36.2479 177.395C36.2479 178.099 35.7839 178.419 34.2319 178.419C32.5679 178.419 31.9439 178.083 31.9439 177.043V176.915H30.2159V176.963C30.2159 178.803 31.6719 179.811 34.2319 179.811ZM42.5026 179.811C44.5506 179.811 45.6066 178.531 45.8626 177.187H45.9586V179.651H47.5426V171.699H45.8306V175.635C45.8306 177.363 45.0146 178.259 43.2546 178.259C41.5746 178.259 40.8866 177.507 40.8866 176.019V171.699H39.1746V176.483C39.1746 178.323 40.2626 179.811 42.5026 179.811ZM50.8405 179.651V175.187C50.8405 173.763 51.4005 173.011 52.7605 173.011C53.9445 173.011 54.4245 173.539 54.4245 174.675V175.379H56.1365V174.339C56.1365 172.835 55.3525 171.539 53.5445 171.539C51.9125 171.539 51.0485 172.563 50.8085 173.843H50.6965V171.699H49.1125V179.651H50.8405ZM59.5579 179.811C61.3659 179.811 62.6299 179.011 63.0459 177.667H63.1579V179.651H64.7419V174.819C64.7419 172.915 63.6059 171.539 61.0779 171.539C58.5499 171.539 57.0459 172.899 57.0459 174.707V174.771H58.7579V174.707C58.7579 173.539 59.4779 173.059 60.9499 173.059C62.4699 173.059 63.0459 173.523 63.0459 174.835V175.299L59.4299 175.683C57.8619 175.859 56.8699 176.499 56.8699 177.731C56.8699 179.043 57.9099 179.811 59.5579 179.811ZM58.5979 177.619C58.5979 176.995 59.0299 176.787 59.9259 176.675L63.0459 176.323C63.0459 177.891 61.8299 178.563 60.0219 178.563C59.0299 178.563 58.5979 178.259 58.5979 177.619ZM68.0124 179.651V175.715C68.0124 173.987 68.7964 173.091 70.5404 173.091C72.1884 173.091 72.8604 173.843 72.8604 175.331V179.651H74.5884V174.867C74.5884 173.027 73.5004 171.539 71.2924 171.539C69.2764 171.539 68.2204 172.819 67.9804 174.163H67.8684V171.699H66.2844V179.651H68.0124ZM80.1441 179.811C82.5281 179.811 84.2721 178.467 84.2721 176.483V176.307H82.5601V176.419C82.5601 177.651 81.6641 178.259 80.1121 178.259C78.3201 178.259 77.5201 177.395 77.5201 175.683C77.5201 173.939 78.3201 173.091 80.1121 173.091C81.6641 173.091 82.5601 173.699 82.5601 174.931V175.027H84.2721V174.867C84.2721 172.883 82.5281 171.539 80.1441 171.539C77.5201 171.539 75.8081 173.203 75.8081 175.683C75.8081 178.131 77.5201 179.811 80.1441 179.811ZM89.55 179.811C91.918 179.811 93.582 178.643 93.582 176.947V176.803H91.854V176.931C91.854 177.875 91.166 178.419 89.502 178.419C87.662 178.419 86.91 177.603 86.846 176.067H93.598C93.646 175.827 93.662 175.603 93.662 175.315C93.662 172.899 91.982 171.539 89.518 171.539C86.926 171.539 85.23 173.203 85.23 175.683C85.23 178.339 86.942 179.811 89.55 179.811ZM89.486 172.899C91.182 172.899 92.03 173.603 92.03 175.075V175.107H86.862C86.958 173.683 87.726 172.899 89.486 172.899Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 28.8237,
    y1: 131.118,
    x2: 28.8237,
    y2: -10.3968,
    stroke: "url(#paint0_linear_51_1914)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.8237,
    y1: 131.118,
    x2: 64.8237,
    y2: -10.3968,
    stroke: "url(#paint1_linear_51_1914)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.824,
    y1: 131.118,
    x2: 100.824,
    y2: -10.3968,
    stroke: "url(#paint2_linear_51_1914)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.824,
    y1: 131.118,
    x2: 135.824,
    y2: -10.3968,
    stroke: "url(#paint3_linear_51_1914)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 29.9794,
    x2: 198.245,
    y2: 29.9793,
    stroke: "url(#paint4_linear_51_1914)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 88.9794,
    x2: 198.245,
    y2: 88.9793,
    stroke: "url(#paint5_linear_51_1914)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 58.9794,
    x2: 198.245,
    y2: 58.9793,
    stroke: "url(#paint6_linear_51_1914)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1505,
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "url(#paint7_linear_51_1914)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8046 37.6058C52.5873 37.3998 52.2994 37.285 52 37.285C51.7007 37.285 51.4127 37.3998 51.1955 37.6058C47.8857 40.749 43.4775 42.4726 38.9135 42.4082C38.6648 42.405 38.4216 42.4811 38.2192 42.6255C38.0168 42.7699 37.8656 42.975 37.7877 43.2112C37.1297 45.2166 36.7955 47.3141 36.7976 49.4247C36.7976 58.6896 43.1343 66.4717 51.7085 68.678C51.8997 68.7273 52.1004 68.7273 52.2916 68.678C60.8658 66.4717 67.2024 58.6896 67.2024 49.4247C67.2024 47.2574 66.8547 45.168 66.2123 43.2112C66.1347 42.9748 65.9837 42.7692 65.7812 42.6245C65.5788 42.4798 65.3354 42.4035 65.0866 42.4066L64.8636 42.4082C60.1922 42.4082 55.9495 40.5839 52.8046 37.6058ZM57.6288 50.1045C57.7224 49.9799 57.7901 49.8378 57.8279 49.6866C57.8658 49.5354 57.873 49.3781 57.8492 49.2241C57.8254 49.0701 57.7711 48.9224 57.6894 48.7896C57.6077 48.6569 57.5003 48.5418 57.3735 48.4512C57.2467 48.3606 57.1031 48.2962 56.951 48.2619C56.799 48.2275 56.6417 48.224 56.4882 48.2513C56.3348 48.2787 56.1884 48.3364 56.0576 48.4212C55.9268 48.506 55.8142 48.616 55.7266 48.7449L50.6809 55.8082L48.1488 53.276C47.9271 53.0694 47.6339 52.957 47.3309 52.9623C47.0279 52.9676 46.7389 53.0904 46.5246 53.3046C46.3104 53.5189 46.1876 53.8079 46.1823 54.1109C46.177 54.4139 46.2894 54.7071 46.496 54.9287L50.0042 58.437C50.1243 58.557 50.269 58.6493 50.4283 58.7078C50.5877 58.7662 50.7578 58.7892 50.9269 58.7752C51.096 58.7613 51.2601 58.7107 51.4077 58.627C51.5553 58.5433 51.683 58.4284 51.7817 58.2904L57.6288 50.1045Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1505,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "url(#paint8_linear_51_1914)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_1914",
    x1: 29.3237,
    y1: 9.68107,
    x2: 29.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_1914",
    x1: 65.3237,
    y1: 9.68107,
    x2: 65.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_1914",
    x1: 101.324,
    y1: 9.68107,
    x2: 101.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_1914",
    x1: 136.324,
    y1: 9.68107,
    x2: 136.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_1914",
    x1: -60.1421,
    y1: 30.4794,
    x2: 195.012,
    y2: 30.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_1914",
    x1: -60.1421,
    y1: 89.4794,
    x2: 195.012,
    y2: 89.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_1914",
    x1: -60.1421,
    y1: 59.4794,
    x2: 195.012,
    y2: 59.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_1914",
    x1: 52.5,
    y1: 16.6505,
    x2: 52.5,
    y2: 88.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_51_1914",
    x1: 52.5,
    y1: 16.6505,
    x2: 52.5,
    y2: 88.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1914"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650513,
    width: 160,
    height: 200,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact4);
export default __webpack_public_path__ + "static/media/contact4.7728e1cea80bb375bb403de0acedf0e8.svg";
export { ForwardRef as ReactComponent };